import * as React from 'react';
import LayoutDefault from './components/layouts/Default';
import LayoutModalFilters from './components/layouts/ModalFilters';
import { SettingsContext } from './contexts/settings';
import { IAppSettings } from './types';

interface IProps {
	settings: IAppSettings;
}

const App = ({ settings }: IProps) => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const renderLayout = (layout: string) => {
		let LayoutOutput = LayoutDefault;
		switch (layout) {
			case 'modal': {
				LayoutOutput = LayoutModalFilters;
				break;
			}
		}

		return <LayoutOutput />;
	};

	return (
		<SettingsContext.Provider value={settings}>
			{renderLayout(settings.layout)}
		</SettingsContext.Provider>
	);
};

App.displayName = 'App';

export default App;
